import { render } from "./Address.vue?vue&type=template&id=fa3050c8"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=fa3050c8&lang=less"
script.render = render

export default script